import {Routes} from '@angular/router';

export const content: Routes = [
  {
    path: '',
    loadChildren: () => import('../../layouts/components/dashboard/home.module').then(m => m.HomeModule),
  },
  {
    path: 'general',
    loadChildren: () => import('../../layouts/components/general/general.module').then(m => m.GeneralModule)
  },
  {
    path: 'phases',
    loadChildren: () => import('../../layouts/components/phases/phases.module').then(m => m.PhasesModule)
  },
  {
    path: 'leads',
    loadChildren: () => import('../../layouts/components/lead/lead.module').then(m => m.LeadModule)
  },
  {
    path: 'students',
    loadChildren: () => import('../../layouts/components/student/student.module').then(m => m.StudentModule)
  },
  {
    path: 'ivr',
    loadChildren: () => import('../../layouts/components/ivr/ivr.module').then(m => m.IvrModule)
  },
  {
    path: 'accounts',
    loadChildren: () => import('../../layouts/components/account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'tickets',
    loadChildren: () => import('../../layouts/components/ticket/ticket.module').then(m => m.TicketModule)
  },
  {
    path: 'notification',
    loadChildren: () => import('../../layouts/components/notification/notification.module').then(m => m.NotificationModule)
  },
  {
    path: 'help',
    loadChildren: () => import('../../layouts/components/help-and-support/help-and-support.module').then(m => m.HelpAndSupportModule)
  },
  {
    path: 'apps',
    loadChildren: () => import('../../layouts/components/app/app.module').then(m => m.AppModule)
  },
  {
    path: 'receipt',
    loadChildren: () => import('../../layouts/components/receipt/receipt.module').then(m => m.ReceiptModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('../../layouts/components/profile/profile.module').then(m => m.ProfileModule)
  },
  {
    path: 'upgrade-plan',
    loadChildren: () => import('../../layouts/components/upgrade-plan/upgrade-plan-routing.module').then(m => m.UpgradePlanRoutingModule)
  }
];

export const landing: Routes = [
  {
    path: 'landing',
    loadChildren: () => import('../../landing/pages-list/Landing/Landing.module').then(m => m.LandingModule)
  }
]
